export default __webpack_public_path__ + "static/media/AYM Syntex Limited.d6772fe7.jpg";